module.exports = __webpack_public_path__ + "static/media/toujiao2.1bafcd2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toujiao2.mp4
// module id = NfBy
// module chunks = 1